import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import useMediaQuery from '@mui/material/useMediaQuery';
import { alpha, useTheme } from '@mui/material/styles';
import { colors } from '@mui/material';

const mock = [
  {
    title: 'Alumni 2019 - 20',
    description:
      'Creating an engaged, supportive alumni network is crucial to an institutions success. If communication stops once graduates leave an institution, they connect with the part of them will be lost. ... Good alumni relationships bring many benefits to both the institution and the alumni.',
    illustration:
      '//pic.onlinewebfonts.com/svg/img_135736.png',
    illustrationDark:
      '//pic.onlinewebfonts.com/svg/img_135736.png',
    
    color: colors.blue[200],
  },
  {
    title: 'Alumni 2018 - 19',
    description:
      'The school congratulates the students of Class 12 (2018-19) for their not able accomplishments and placements. Leading the pedestal of ',
    illustration:
      '//pic.onlinewebfonts.com/svg/img_135736.png',
    illustrationDark:
      '//pic.onlinewebfonts.com/svg/img_135736.png',
    color: colors.purple[200],
  },
  // {
  //   label: '.',
  //   title: 'Alumni 2016 - 17',
  //   description:
  //     'The Students of National public School, batch of 2017, have made the Alma-Mater proud by securing seats in the prestigious institutions across the country and at International Level to pursue their aspirations. As the 26 gems who graduated gain a foothold in the path to achieve their dreams, the school wishes them all the best in their endeavours.',
  //   lustration:
  //     '//pic.onlinewebfonts.com/svg/img_135736.png',
  //   illustrationDark:
  //     '//pic.onlinewebfonts.com/svg/img_135736.png',
  //   color: colors.indigo[200],
  // },
  {
    title: 'Alumni 2017 - 18',
    description:
      'The School congratulates the Students of Class 12 (2017 - 2018) for their meritorio accomplishments.Presenting the notable accomplishments: The School also congratulates the other Students who have joined premier institution across the country to pursue varied fields like Computer Engineering, Mechanical Engineering.',
    illustration:
      '//pic.onlinewebfonts.com/svg/img_135736.png',
    illustrationDark:
      '//pic.onlinewebfonts.com/svg/img_135736.png ',
    color: colors.green[200],
  },
];

const Nike2 = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{
            textTransform: 'uppercase',
            fontWeight: 'medium',
          }}
          gutterBottom
          color={'secondary'}
        >
          
        </Typography>
        <Typography
          variant="h4"
          data-aos={'fade-up'}
          gutterBottom
          align='center'
          sx={{
            fontWeight: 700,
          }}
        >
          Alumni
        </Typography>
       
        {/* <Button
          variant="contained"
          color="primary"
          size="large"
          sx={{ marginTop: 2 }}
        >
          View all
        </Button> */}
      </Box>
      <Grid container spacing={isMd ? 8 : 4}>
        {mock.map((item, i) => (
          <Grid
            key={i}
            item
            xs={8}
            md={4}
            data-aos="fade-up"
            data-aos-delay={i * 100}
            data-aos-offset={100}
            data-aos-duration={600}
          >
            <Box
              component={Card}
              height={1}
              bgcolor={alpha(item.color, 0.2)}
              boxShadow={0}
              // sx={{
              //   transform: i % 2 === 1 ? { md: 'none' } : 'none',
              // }}
            >
              <CardContent sx={{ padding: 4 }}>
                <Box
                  display={'flex'}
                  justifyContent={'center'}
                  marginBottom={{ xs: 2, md: 4 }}
                  sx={{
                    '& .lazy-load-image-loaded': {
                      maxWidth: { xs: '80%', md: '70%' },
                    },
                  }}
                >
                  <Box
                    component={LazyLoadImage}
                    effect="blur"
                    src={
                      theme.palette.mode === 'light'
                        ? item.illustration
                        : item.illustrationDark
                    }
                    width={1}
                  />
                </Box>
                <Box>
                  <Typography
                    variant={'h6'}
                    gutterBottom
                    sx={{ fontWeight: 700 }}
                  >
                    {item.title}
                  </Typography>
                  <Typography color="text.secondary" align='justify'>
                    {item.description}
                  </Typography>
                  <Button
                    size={'large'}
                    sx={{ marginTop: 2 }}
                    endIcon={
                      <Box
                        component={'svg'}
                        xmlns="https://www.npsypr.com/pdf/2019-20/alumni_2k18_19.pdf"
                       
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        width={24}
                        height={24}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17 8l4 4m0 0l-4 4m4-4H3"
                        />
                      </Box>
                    }
                  >
                    
                    <a href="https://www.npsypr.com/pdf/2019-20/alumni_2k18_19.pdf" target="blank"><h4>Read more</h4></a>
                  </Button>
                </Box>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Nike2;
